/** 方便 mjs 文件引用，该文件采用js */
/** CDN 容灾 IndexedDB 常量，供 TS 模块和 Node.js 构建脚本共用 */

export const CDN_IDB_NAME = 'cdn-failover';
export const CDN_IDB_STORE = 'kv';
export const CDN_IDB_KEY = '__cdn_ok__';

/**
 * localStorage key：记录最近一次成功的 CDN 域名
 * value 结构：{ domain: string; ts: number }
 */
export const CDN_LAST_OK_KEY = '__cdn_ok__';

/** CDN 可用记录有效期（毫秒），1 天 */
export const CDN_LAST_OK_TTL = 86_400_000;

/** localStorage / IDB key：DoH 查询结果缓存 */
export const CDN_DOH_CACHE_KEY = '__cdn_doh__';

/** DoH IDB record key */
export const CDN_DOH_IDB_KEY = '__cdn_doh__';

/** DoH 缓存有效期（毫秒），10 分钟 */
export const CDN_DOH_TTL = 600_000;

/** DoH TXT 记录 AES-256-GCM 解密 key */
export const CDN_DOH_AES_KEY = 'hq8E6KKIR4pMhnQvupRsxe2KWqtDfemX';

/** DoH 服务商端点：Cloudflare（优先） */
export const CDN_DOH_CF_URL = 'https://cloudflare-dns.com/dns-query';

/** DoH 服务商端点：Google（备用） */
export const CDN_DOH_GG_URL = 'https://dns.google/resolve';

/** 单个资源最大重试次数（onerror 层和 SW 层共用） */
export const MAX_RETRY_PER_RESOURCE = 3;

/** 需要拦截重试的资源路径前缀（onerror 层、SW 层、inject 脚本共用） */
export const CDN_RESOURCE_PREFIXES = ['/_next/static/', '/assets/', '/fonts/', '/scripts/'];

/**
 * 容灾判断滑动窗口（毫秒）：窗口内累计不同路径失败数达到阈值才认定为真实容灾。
 * onerror 层和 SW 层共用同一套参数，保持判断行为一致。
 */
export const CDN_FAILURE_WINDOW_MS = 5000;
// 单个请求愿意为这轮故障确认等多久
export const CDN_PENDING_REQUEST_TIMEOUT_MS = 1500;

/** 容灾判断失败阈值：窗口内同一 origin 下不同 pathname 失败数达到此值触发容灾 */
export const CDN_FAILURE_THRESHOLD = 5;

/** IDB key：记录容灾确认状态，供 SW activate 阶段读取，早于主线程 postMessage */
export const CDN_FAILOVER_CONFIRMED_IDB_KEY = '__cdn_failover_confirmed__';

/** sessionStorage key：标记当前 tab 已触发过容灾确认，刷新后保留，tab 关闭后自动清除 */
export const CDN_FAILOVER_SESSION_TOKEN_KEY = '__cdn_failover_session__';
